import styled from 'styled-components';
import {
  variant,
  gridGap,
  gridTemplateColumns,
  display,
  GridProps,
  DisplayProps,
} from 'styled-system';

import { ThemeUtilities } from '../../../theme';

import { Size, Variant, Status } from './types';

export const Card = styled.div<{
  size: Size;
  variant: Variant;
  status?: Status;
}>`
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  overflow: hidden;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'CreditCard', 'size'))};

  ${(props) =>
    variant(
      ThemeUtilities.getComponentVariant(props, 'CreditCard', 'variant')
    )};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'CreditCard', 'status'))};
`;

export const AddressWrapper = styled.div`
  min-width: 0;
  margin-left: auto;
`;

export const CardNumberWrapper = styled.div`
  margin-top: auto;
  margin-bottom: auto;
`;

export const Row = styled.div<GridProps & DisplayProps>`
  display: grid;
  align-items: center;

  ${gridGap};
  ${gridTemplateColumns};
  ${display};
`;
